module.exports = __webpack_public_path__ + "static/media/thank-you-tracking-on.56201937.svg";